module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "meio"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "creditos"
    }
  }, [_c('div', {
    staticClass: "copy"
  }, [_vm._v("© " + _vm._s(_vm.ano) + " Soluti - Todos os direitos reservados\n         "), _c('br'), _vm._v("\n         v2.3.0\n       ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "end"
  }, [_c('h4', [_vm._v("Central de Atendimento")]), _vm._v(" "), _c('p', [_vm._v("\n         Av. 136, nº 797, 19º andar, salas 1901B a 1905B Ed, New York - Setor Sul"), _c('br'), _vm._v("\n         Goiânia - GO CEP: 74093-250\n       ")]), _vm._v(" "), _c('strong', [_vm._v("Telefones")]), _vm._v(" "), _c('p', [_vm._v("0800 941 6601")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f33ff714!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 108
// module chunks = 0